import { React, ReactDOM, setOverrideAPI } from 'mcelroy-lib'
import { McElroyApp } from 'mcelroy-components'
import { AccountPage } from './pages/account/AccountPage'
import { CreateAccountPage } from './pages/CreateAccountPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { UsersPage } from './pages/UsersPage'
import { UserProfilePage } from './pages/UserProfilePage'
import { ChangePasswordPage } from './pages/ChangePasswordPage'
import { DistributorLocationsPage } from './pages/DistributorLocationsPage'
import { DistributorPage } from './pages/DistributorPage'
import { LicensePage } from './pages/LicensePage'
import { LocalizedResourcesPage } from './pages/LocalizedResourcesPage'
import { TranslationPage } from './pages/TranslationPage'
import { BatchTranslationPage } from './pages/BatchTranslationPage'

API_OVERRIDE && setOverrideAPI(API_OVERRIDE)

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

const routes = [
  {
    path: "/",
    element: <AccountPage />,
    handle: {
      title: 'Account'
    }
  },
  {
    path: "/test",
    element: <AccountPage />,
    handle: {
      title: 'Account'
    }
  },
  {
    path: "/license",
    element: <LicensePage />
  },
  {
    path: "/create",
    element: <CreateAccountPage />
  },
  {
    path: "/reset_password",
    element: <ResetPasswordPage />
  },
  {
    path: "/distributors",
    element: <DistributorLocationsPage />,
    handle: {
      title: 'Distributors',
      active: function (user) {
        return user.isEmployee || user.isDistributor
      }
    }
  },
  {
    path: "/distributors/:distributor_id",
    element: <DistributorPage />
  },
  {
    path: "/create_distributor",
    element: <DistributorPage />
  },
  {
    path: "/users",
    element: <UsersPage />,
    handle: {
      title: 'Users',
      active: function (user) {
        return user.isUserAdmin
      }
    }
  },
  {
    path: "/users/:user_id",
    element: <UserProfilePage />
  },
  {
    path: "/changePassword/:user_id",
    element: <ChangePasswordPage />
  },
  {
    path: "/localizedResources",
    element: <LocalizedResourcesPage />,
    handle: {
      title: 'Translations',
      active: function (user) {
        return user.hasRoles(['TranslationAdmin'])
      }
    }
  },
  {
    path: "/translations/:lang/:key",
    element: <TranslationPage />
  },
  {
    path: "/create_translation",
    element: <TranslationPage />
  },
  {
    path: "/batch_translation",
    element: <BatchTranslationPage />
  }
]

root.render(<McElroyApp title="McElroy" routes={routes} login="name only" />)
